// tabs/RestauranteTabPanel/index.js
import React, { useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Box, Tooltip, IconButton, Button } from '@mui/material';
import { MaterialReactTable } from 'material-react-table';
import { AddShoppingCart, ShoppingCart, RemoveShoppingCart } from '@mui/icons-material';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import Input from '../../../../../form/Input';
import InputNumber from '../../../../../form/InputNumber';
import DataList from '../../../../../form/DataList';
import Select from '../../../../../form/Select';
import Checkbox from '../../../../../form/Checkbox';
import TextArea from '../../../../../form/TextArea';
import { retornaData } from '../../../../../../utils/retornaDataFormatada';

export default function RestauranteTabPanel({ theme, module, header, config, perms }) {
    const main = module?.main || {};
    const draft = module?.draft || {};
    const list = module?.list || {};
    const mrt = module?.mrt || {};
    const flags = module?.flags || {};
    const actions = module?.actions || {};
    const state = module?.state || {};

    const dados = header?.dados || {};
    const Parceiro = header?.Parceiro || {};
    const Colaborador = header?.Colaborador || {};
    const OptionsParceiro = header?.OptionsParceiro || [];
    const OptionsColaborador = header?.OptionsColaborador || [];
    const OptionsSituacao = header?.OptionsSituacao || [];
    const OptionsTabelaPreco = header?.OptionsTabelaPreco || [];
    const onChange = header?.onChange || (() => {});
    const onFocus = header?.onFocus || (() => {});
    const onBlur = header?.onBlur || (() => {});
    const isDisabledCusto = !header?.isDisabledCusto ?? false; // quando funcionario habilita

    const operacao = config?.operacao || {};
    const operacaoParametros = config?.operacaoParametros || {};
    const profile = config?.profile || {};
    const titleHeaderGrid = config?.titleHeaderGrid || 'Itens';
    const utiliza3digitos = config?.utiliza3digitos ?? false;
    const casaDecimal = config?.casaDecimal ?? 2;
    const formatarNumero = config?.formatarNumero || ((v) => v);
    const formatarNumero3Digitos = config?.formatarNumero3Digitos || ((v) => v);

    const podeEditarItem = perms?.podeEditarItem ?? false;
    const podeIncluir = perms?.podeIncluir ?? false;
    const podeCancelarItem = perms?.podeCancelarItem ?? false;

    const { modoTabelaPreco } = state;
    const novoProduto = draft?.value || state?.draft || {};

    const data = modoTabelaPreco
        ? (list?.items ?? state?.itensProdutos ?? [])
        : (list?.view ?? list?.items ?? state?.itensProdutos ?? []);

    const rowCount = modoTabelaPreco ? data.length : (list?.rowCount ?? state?.rowCountProduto ?? data.length);

    const Produto = state?.Produto || {};
    const OptionsProdutos = state?.OptionsProdutos || [];
    const OptionsEmbalagem = state?.OptionsEmbalagem || [];

    const manual = !!main?.state?.id && !modoTabelaPreco;

    const columnFilterFns = mrt?.state?.columnFilterFns || {};
    const columnFilters = mrt?.state?.columnFilters || [];
    const globalFilter = mrt?.state?.globalFilter || '';
    const pagination = mrt?.state?.pagination || { pageIndex: 0, pageSize: 5 };
    const sorting = mrt?.state?.sorting || [];

    const setColumnFilters = mrt?.setters?.setColumnFilters || (() => {});
    const setColumnFilterFnsMode = mrt?.setters?.setColumnFilterFnsMode || (() => {});
    const setGlobalFilter = mrt?.setters?.setGlobalFilter || (() => {});
    const setPagination = mrt?.setters?.setPagination || (() => {});
    const setSorting = mrt?.setters?.setSorting || (() => {});

    const isError = mrt?.flags?.isError ?? false;
    const isLoading = mrt?.flags?.isLoading ?? false;
    const isRefetching = mrt?.flags?.isRefetching ?? false;

    const onLimpar = actions?.clear || (() => {});
    const onSalvarItem = actions?.submitDraft || actions?.save || (async () => {});
    const onItemAction = actions?.selectRow || (() => {});

    // controla o duplo click
    const disabledBtnItem = perms?.disabledBtnItem ?? false;
    const isSaving = flags?.isSaving ?? false;

    const columns = useMemo(
        () => [
            {
                id: 'produto',
                header: titleHeaderGrid,
                columns: [
                    {
                        accessorKey: 'Produto.descricao',
                        id: 'Produto.descricao',
                        header: 'Descrição',
                        muiTableBodyCellProps: ({ row }) => ({
                            onClick: () => {
                                console.info(row.original);
                            },
                        }),
                    },
                    {
                        accessorKey: 'quantidade',
                        header: 'Quantidade',
                        muiTableBodyCellProps: { align: 'right' },
                        accessorFn: (row) =>
                            !row.quantidade
                                ? ''
                                : parseFloat(row.quantidade)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: casaDecimal,
                                      maximumFractionDigits: casaDecimal,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'Embalagem.descricao',
                        id: 'Embalagem.descricao',
                        header: 'Embalagem',
                    },
                    {
                        accessorKey: 'precoNegociado',
                        header: 'Valor Unitário',
                        muiTableBodyCellProps: { align: 'right' },
                        accessorFn: (row) =>
                            !row.precoNegociado
                                ? ''
                                : 'R$ ' +
                                  parseFloat(row.precoNegociado)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'valorTotal',
                        header: 'Valor Total',
                        muiTableBodyCellProps: { align: 'right' },
                        accessorFn: (row) =>
                            !row.valorTotal
                                ? ''
                                : 'R$ ' +
                                  parseFloat(row.valorTotal)?.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: 'observacao',
                        header: 'Observação',
                    },
                    {
                        accessorKey: 'prato',
                        header: 'Prato',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: 1 },
                            { label: 'Não', value: 0 },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.prato;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                ],
            },
        ],
        [titleHeaderGrid, casaDecimal]
    );

    const ui = profile?.uiTabs;
    const labParceiro = ui?.cabecalho?.labels?.labParceiro;
    const labColaborador = ui?.cabecalho?.labels?.labColaborador;

    return (
        <div style={{ margin: '1em' }}>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                <Input
                    text="Data"
                    type="date"
                    name="data"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados?.data && retornaData(dados.data)}
                />

                <DataList
                    text={labParceiro}
                    name="Parceiro.descricao"
                    placeholder={`Pesquise o ${labParceiro}`}
                    filteredOptions={OptionsParceiro}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={Parceiro?.descricao || ''}
                    required
                />

                <Checkbox
                    title="Esse movimento será contabilizado como custo para a empresa"
                    text="Custo"
                    name="custo"
                    handleOnChange={onChange}
                    value={dados?.custo}
                    checked={!!dados?.custo}
                    disabled={dados?.custoFilial || isDisabledCusto}
                />

                <Checkbox
                    title="Esse movimento será replicado na filial com seu financeiro invertido"
                    text="Custo Filial"
                    name="custoFilial"
                    handleOnChange={onChange}
                    value={dados?.custoFilial}
                    checked={!!dados?.custoFilial}
                    disabled={dados?.custo || isDisabledCusto}
                />

                <Select
                    name="situacaoId"
                    text="Situação"
                    inputWidth="170px"
                    options={OptionsSituacao}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados?.situacaoId ?? operacaoParametros?.situacaoId}
                    isEnum={false}
                    notOptNull={true}
                    disabled={operacaoParametros?.situacaoIdIsDisabled}
                />

                <DataList
                    text={labColaborador}
                    name="Colaborador.descricao"
                    placeholder={`Pesquise o ${labColaborador}`}
                    filteredOptions={OptionsColaborador}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={Colaborador?.descricao || ''}
                    required
                />

                <Select
                    name="novoProduto.tabelaPrecoId"
                    title="Escolha a tabela de preço"
                    text="Tabela de Preço"
                    inputWidth="130"
                    options={OptionsTabelaPreco}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={novoProduto?.tabelaPrecoId}
                    isEnum={false}
                    notOptNull={false}
                />

                <InputNumber
                    text="Total do Pedido"
                    type="text"
                    name="totalValor"
                    inputWidth="120px"
                    value={dados?.totalValor ? formatarNumero(dados.totalValor) : ''}
                    readonly
                />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                <DataList
                    text="Produto"
                    name="Produto.descricao"
                    placeholder="Pesquise o Produto"
                    filteredOptions={OptionsProdutos}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={Produto?.descricao || ''}
                />

                <Select
                    name="novoProduto.embalagemId"
                    text="Embalagem"
                    options={OptionsEmbalagem}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={novoProduto?.embalagemId}
                    isEnum={false}
                    notOptNull={true}
                />

                <InputNumber
                    text="Quantidade"
                    type="text"
                    name="novoProduto.quantidade"
                    inputWidth="100px"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={
                        novoProduto?.quantidade
                            ? utiliza3digitos
                                ? formatarNumero3Digitos(novoProduto.quantidade)
                                : formatarNumero(novoProduto.quantidade)
                            : ''
                    }
                />
                <InputNumber
                    text="Preço"
                    type="text"
                    name="novoProduto.precoNegociado"
                    placeholder="Valor R$"
                    inputWidth="100px"
                    title="preço negociado, esse valor será validado pelas regras disponíveis no sistema"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={novoProduto?.precoNegociado ? formatarNumero(novoProduto.precoNegociado) : ''}
                    readonly={false}
                />

                <InputNumber
                    text="Total"
                    type="text"
                    name="novoProduto.valorTotal"
                    inputWidth="100px"
                    value={novoProduto?.valorTotal ? formatarNumero(novoProduto.valorTotal) : ''}
                    readonly
                />

                <Button
                    variant="contained"
                    color="inherit"
                    onClick={onLimpar}
                    style={{
                        marginLeft: '10px',
                        minWidth: '80px',
                        fontSize: '14px',
                    }}
                >
                    Limpar
                </Button>

                <Button
                    variant="contained"
                    color={novoProduto?.funcao?.toLowerCase() === 'cancelar' ? 'error' : 'info'}
                    onClick={onSalvarItem}
                    disabled={disabledBtnItem || isSaving}
                    style={{ marginLeft: '10px', minWidth: '80px', fontSize: '14px' }}
                >
                    {isSaving ? 'Processando...' : novoProduto?.funcao}
                </Button>
            </div>

            <div>
                <TextArea
                    text="Observações no item"
                    name="novoProduto.observacao"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={novoProduto?.observacao || ''}
                    linhas="2"
                    colunas="60"
                />
            </div>

            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    columns={columns}
                    data={data}
                    rowCount={rowCount}
                    getRowId={(row) => row.uuid}
                    manualPagination={!!manual}
                    manualSorting={!!manual}
                    manualFiltering={!!manual}
                    enableColumnFilterModes
                    enableGlobalFilterModes
                    enableColumnOrdering
                    enableEditing
                    enableRowSelection
                    localization={MRT_Localization_PT_BR}
                    initialState={{ showColumnFilters: true, density: 'compact' }}
                    muiToolbarAlertBannerProps={isError ? { color: 'error', children: 'Error loading data' } : undefined}
                    onColumnFiltersChange={setColumnFilters}
                    onColumnFilterFnsChange={setColumnFilterFnsMode}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    state={{
                        columnFilterFns,
                        columnFilters,
                        globalFilter,
                        isLoading,
                        pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting,
                    }}
                    positionExpandColumn="first"
                    positionActionsColumn="first"
                    positionToolbarAlertBanner="bottom"
                    renderDetailPanel={({ row }) => (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', padding: '10px' }}>
                            <Box sx={{ fontWeight: 'bold', fontSize: '16px' }}>Observação: {row.original.observacao}</Box>
                        </Box>
                    )}
                    renderRowActions={({ row }) => (
                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                            <Tooltip arrow placement="left" title={`${row.original.pedido === true ? 'Editar' : 'Adicionar'}`}>
                                <span>
                                    <IconButton
                                        onClick={() => onItemAction(row.original, row.index, 'Editar')}
                                        disabled={isSaving || (row.original.pedido === true ? !podeEditarItem : !podeIncluir)}
                                    >
                                        {row.original.pedido === true ? <ShoppingCart /> : <AddShoppingCart />}
                                    </IconButton>
                                </span>
                            </Tooltip>

                            <Tooltip arrow placement="right" title="Cancelar">
                                <span>
                                    <IconButton
                                        color="error"
                                        onClick={() => onItemAction(row.original, row.index, 'Cancelar')}
                                        disabled={isSaving || row.original.pedido !== true || !podeCancelarItem}
                                    >
                                        <RemoveShoppingCart />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Box>
                    )}
                />
            </ThemeProvider>
        </div>
    );
}
